module.exports = __webpack_public_path__ + "img/result-header.a629173e.png";